import React from 'react';

import { BaseSlider } from '$partials/fields/slider';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/filters/individual.d.ts').RangeSlider}
 */
export const RangeSlider = ({
    label,
    max = 1,
    maxDisplay,
    min = 0,
    minDisplay,
    name,
    onChange,
    step = 1,
    value,
}) => {
    return (
        <fieldset>
            {label &&
                <legend className='block mb-16 type-style-eyebrow'>
                    {label}
                </legend>
            }

            <BaseSlider
                max={max}
                min={min}
                name={name}
                onDebouncedChange={onChange}
                step={step}
                value={value} />

            <div className='flex w-full mt-8 whitespace-nowrap type-style-eyebrow'>
                <div className='w-full'>
                    <div className='text-[9px]'>
                        Min
                    </div>
                    <div>
                        {minDisplay || value[0]}
                    </div>
                </div>
                <div className='text-right'>
                    <div className='text-[9px]'>
                        Max
                    </div>
                    <div>
                        {maxDisplay || value[1]}
                    </div>
                </div>
            </div>
        </fieldset>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default RangeSlider;
